/**
 * Add in API requests to pre-fetch at the start of the application.
 * Application load should not block on these requests.
 */
define('router/router-tasks/pre-fetch',['require','api-access','api-access'],function (require) {
    var userApi = require('api-access').user;
    var commerceApi = require('api-access').commerce;

    return function () {
        userApi.me().then(function () {
            commerceApi.getBilling();
        });
    };
});

